import { addCommasToNumber, GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { useState } from 'react'
import { RightOutlined, DownOutlined } from '@ant-design/icons'
import { SimpleRow } from '@components/InventoryValuation/Costing/Details/SimpleRow'
import type { InferResponse } from '@/hooks/useApiClient'

type DrawsProps = {
  index: number
  layer: NonNullable<InferResponse<'/valuation/costing/details'>>['sale_layers'][number]
  formattedCurrency: string
  showDate?: boolean
  openOrderModal: (orderId: string) => void
}

export const Draws = ({ index, layer, formattedCurrency, showDate, openOrderModal }: DrawsProps) => {
  const [isExpanded, setIsExpanded] = useState(false)
  return (
    <>
      <Horizontal
        key={`sale-layers-${index}`}
        className='bg-error-dim p-2'
        style={{ borderTop: '2px solid var(--theme-error)' }}
        verticalCenter
      >
        {!!layer?.delivery_layers?.length && (
          <GraviButton
            className='p-2 collapse-arrow'
            title={isExpanded ? 'Collapse' : 'Expand'}
            icon={isExpanded ? <DownOutlined /> : <RightOutlined />}
            onClick={() => setIsExpanded(!isExpanded)}
          />
        )}
        <Texto className='text-error' weight={'bold'}>
          DRAWS
        </Texto>
        <Vertical className='pr-2' flex={7} justifyContent={'center'} alignItems={'flex-end'}>
          <Texto className='text-error text-truncate' weight={'bold'} align={'right'} style={{ width: '100%' }}>
            {addCommasToNumber(layer.volume, 0)}
          </Texto>
        </Vertical>
        <Vertical className='p-2' flex={1} justifyContent={'center'} alignItems={'flex-end'}>
          <Texto className='text-error text-truncate' weight={'bold'} align={'right'} style={{ width: '100%' }}>
            {formattedCurrency}
            {addCommasToNumber(layer.price, 4)}
          </Texto>
        </Vertical>
        <Vertical className='p-2' flex={1} justifyContent={'center'} alignItems={'flex-end'}>
          <Texto className='text-error text-truncate' weight={'bold'} align={'right'} style={{ width: '100%' }}>
            {formattedCurrency}
            {addCommasToNumber(layer.value, 2)}
          </Texto>
        </Vertical>
      </Horizontal>
      {isExpanded &&
        layer.delivery_layers.map((layer, index) => {
          return (
            <SimpleRow
              row={layer}
              formattedCurrency={formattedCurrency}
              showDate={showDate}
              key={`draws-${index}`}
              openOrderModal={openOrderModal}
              isDraw
              isTemp={layer.is_temporary}
            />
          )
        })}
    </>
  )
}
